<template>
  <div>
    <h3 class="subtitle">Провера података пре плаћања</h3>
    <div class="box">
      <p>
        Уплатилац: <strong>{{ uplatilac }}</strong>
      </p>
      <p>
        E-mail уплатиоца: <strong>{{ email }}</strong>
      </p>
      <p>
        Укупан износ за уплату: <strong>{{ ukupnoZaUplatu }} дин.</strong>
      </p>
      <p>
        Број производа у корпи: <strong>{{ korpa.length }}</strong>
      </p>
      <!-- <p>Уплатилац: {{ brojStavki }}</p> -->
    </div>

    <b-button
      class="is-pulled-left"
      tag="router-link"
      :to="{
        path: '/kupovina',
        query: { step: '1' }
      }"
      >&lt;&lt;</b-button
    >
    <!-- <router-link
      to="/placanje"
      class="button is-pulled-right"
      v-show="ukupnoZaUplatu > 0"
      ><strong>Изврши плаћање</strong></router-link
    > -->
    <b-button
      class="button is-pulled-right"
      v-show="ukupnoZaUplatu > 0"
      @click.prevent="onIzvrsiPlacanjeClick()"
      ><strong>Изврши плаћање</strong></b-button
    >
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import PlacanjeService from '../services/PlacanjeService'

export default {
  methods: {
    onIzvrsiPlacanjeClick() {
      console.log(this.narudzbinaId)
      if (!this.narudzbinaId) {
        this.sacuvajKorpu()
      } else {
        this.$router.push({ path: '/placanje' })
      }
    },
    sacuvajKorpu() {
      //console.log('test')
      PlacanjeService.sacuvajKorpu(
        this.korpa,
        this.ukupnoZaUplatu,
        this.uplatilac,
        this.email
      )
        .then(response => {
          this.$Progress.finish()
          if (response.data.status === 'OK') {
            var podaciPlacanja = response.data.podaci
            console.log(podaciPlacanja)
            this.$store.dispatch(
              'placanje/updatePodaciPlacanja',
              podaciPlacanja
            )

            this.$router.push({ path: '/placanje' })
          } else {
            console.log(response.data)
            this.$buefy.snackbar.open({
              message: 'Дошло је до грешке!',
              type: 'is-danger'
            })
          }
        })
        .catch(error => {
          this.$Progress.finish()
          this.$buefy.snackbar.open({
            message: 'Дошло је до грешке!',
            type: 'is-danger'
          })
          console.log(error.response)
          // this.saglasan = false
        })
    }
  },
  computed: {
    // brojStavki() {
    //   return this.korpa.length
    // },
    // ukupnoZaUplatu() {
    //   let u = 0
    //   for (let index = 0; index < this.korpa.length; index++) {
    //     u += this.korpa[index].cena
    //   }
    //   return u
    // },
    // ...mapState(['korpa'])

    ...mapState('placanje', ['korpa', 'uplatilac', 'narudzbinaId', 'email']),
    ...mapGetters('placanje', ['ukupnoZaUplatu'])
  }
}
</script>

<style></style>
